import request from '@/utils/request'

// 预警提醒分页查询页面
export function getWarningTipList(data) {
  return request({
    url: '/health-doctor-assistant/warningTip/queryPage',
    method: 'post',
    data
  })
}
// 预警提醒弹窗展示
export function getAlarmReadFlag(data) {
  return request({
    url: '/health-doctor-assistant/warningTip/getReadFlag',
    method: 'get',
    params: data
  })
}
// 预警弹框点击关闭
export function readWarningTip(data) {
  return request({
    url: '/health-doctor-assistant/warningTip/readWarningTipPop',
    method: 'post',
    data
  })
}
// 登录获取预警提示弹框
export function getLoginWarnigTip(data) {
  return request({
    url: '/health-doctor-assistant/warningTip/loginSendWarningTip',
    method: 'post',
    data
  })
}
